<template>
	<button
		class="checkout-cart-button"
		type="button"
		@click="onClick"
	>
		<span class="checkout-cart-button__count">
			<span
				class="checkout-cart-button__count-text"
				v-html="$t('checkout.itemCount', { number: totalItemsWithoutAdditional })"
			/>
			<SVGMidCircleChevronRight/>
		</span>
		<span
			class="checkout-cart-button__total"
			v-html="$options.filters.fwgpricecent(displayTotal)"
		/>
	</button>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from 'htmlcomponent'

export default {
	props: {
		showCo2: {
			type: Boolean,
			default() {
				return false
			}
		},
		showTip: {
			type: Boolean,
			default() {
				return false
			}
		},
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters("cart", [
			"total",
			"totalWithoutTip",
			"totalWithoutSurcharges",
			"totalWithoutCo2",
			"totalItemsWithoutAdditional",
		]),
		displayTotal() {
			if (!this.showCo2 && !this.showTip) {
				return this.totalWithoutSurcharges;
			}
			else if (this.showCo2 && !this.showTip) {
				return this.totalWithoutTip
			}
			else if (!this.showCo2 && this.showTip) {
				return this.totalWithoutCo2
			}
			else {
				return this.total
			}
		},
	},
	methods: {
		onClick() {
			htmlComponent.send('overlay:open', {type: 'sidebar-cart'});
		},
	}
}
</script>

<style>

</style>
